import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';
import { userSchema } from '@/api/schemas/user-schema';

export const permissionSchema = new schema.Entity(EntityTypes.Permission, {
  user: userSchema,
});
